import {useMemo} from "react";
import UserSession from "./user-session";

export function useUserSession() {
    return useMemo(() => new UserSession(), []);
}
